/* eslint-disable import/prefer-default-export */
import { takeEvery, spawn } from 'redux-saga/effects';

import {
  BOOST_FILTERS,
  BOOSTS_PATH,
  SUBSCRIPTIONS_FILTERS,
} from 'utils/boosts';

import { CAMPAIGN } from 'services/actions/campaignActions';

import {
  fetchSubscribableProducts,
  fetchFilteredProducts,
} from '../fetchProducts/fetchProducts';
import { fetchCampaignData } from '../app/base';
import { fetchFavoritesData } from '../app/sale';

const { REQUEST_BOOSTS_DATA } = CAMPAIGN;

// worker sagas
function* fetchBoostsData(action) {
  const { pathname, rateAndReviewFF } = action.payload;

  yield spawn(fetchCampaignData);
  // get refill products
  yield spawn(fetchFavoritesData);
  if (pathname === BOOSTS_PATH.q1) {
    yield spawn(fetchSubscribableProducts);
    yield spawn(
      fetchFilteredProducts,
      SUBSCRIPTIONS_FILTERS.newlyAdded,
      0,
      8,
      'trending',
      rateAndReviewFF
    );
  } else if (pathname === BOOSTS_PATH.q2) {
    yield spawn(
      fetchFilteredProducts,
      BOOST_FILTERS.fffPicks,
      0,
      8,
      'top_favorites',
      rateAndReviewFF
    );
  }
}

// watcher sagas
export function* watchFetchBoostsData() {
  yield takeEvery(REQUEST_BOOSTS_DATA, fetchBoostsData);
}
